export default __webpack_public_path__ + "static/blog-showcase-81fba0f047aab14624bc8423f2c05aca.jpg";